import { X } from "lucide-react";
import { cn } from "@/components/common/utils";

interface Props {
  label: string;
  disabled?: boolean;
  isSelected: boolean;
  isPending: boolean;
  onClick: () => void;
}

export const ToggleFilterButton = ({
  isSelected,
  isPending,
  onClick,
  label,
  disabled = false,
}: Props) => {
  return (
    <button
      onClick={() => !disabled && onClick()}
      disabled={disabled}
      className={cn(
        "flex flex-row items-center gap-1 rounded-md px-3 py-2 text-sm font-medium transition-colors duration-200 ease-in-out",
        isSelected
          ? "bg-[#29333C] text-white font-medium"
          : disabled
            ? "bg-gray-100 text-gray-400 cursor-not-allowed"
            : "bg-gray-100 text-gray-500 hover:text-gray-700",
        isPending && "opacity-70"
      )}
    >
      <span>{label}</span>
      {isSelected && <X className="h-4 w-4 -my-1 -mr-1" />}
    </button>
  );
};
